import React from "react";
import "./Sections.css";
import logoMasNuevo from '../../../assets/images/imagesFooter/newSectionLogo.png';
import logoMiCuenta from "../../../assets/images/imagesFooter/cuentaSectionLogo.png";
import logoMiniApp from "../../../assets/images/imagesFooter/miniAppSectionLogo.png";
import logoMiniFace from "../../../assets/images/imagesFooter/faceSectionLogo.png";
import logoMiniDevo from "../../../assets/images/imagesFooter/devolSectionLogo.png";
import MyItemLi from "./MyItemLi";
import { myId } from "../../../lib/MyLibrary";
import { MenuCuenta, MenuDevol, MenuMiniApp, MenuNuevo, MenuRedes } from "./MenusSections";


const Sections = () => {
  
  
  return (
    <div className="row sectionsFooter text-secondary fs-6 ">
      <div className="col-12 col-md-6 col-lg-2">
        <img src={logoMasNuevo} alt="logoMasNuevo" />
        <ul className="lomasnuevo">
          {MenuNuevo.map((item)=>{
            return <MyItemLi key={myId()} data={item}/>
          })}
        </ul>
      </div>
      <div className="col-12 col-md-6 col-lg-3">
        <img src={logoMiCuenta} alt="logoMiCuenta" />
        <ul className="micuenta">
        {MenuCuenta.map((item)=>{
            return <MyItemLi key={myId()} data={item}/>
          })}
        </ul>
      </div>
      <div className="col-0 col-lg-3 d-none d-lg-block">
        <img src={logoMiniDevo} alt="logoMiniDevo" />
        <ul>
        {MenuDevol.map((item)=>{
            return <MyItemLi key={myId()} data={item}/>
          })}
        </ul>
      </div>

      <div className="col-12 col-lg-2">
        <img src={logoMiniApp} alt="logoMiniApp" />
        <ul className="minisoapp">
        {MenuMiniApp.map((item)=>{
            return <MyItemLi key={myId()} data={item}/>
          })}
        </ul>
      </div>
      <div className="col-12 col-lg-2">
        <img src={logoMiniFace} alt="logoMiniFace" />
        <ul className="facebook">
        {MenuRedes.map((item)=>{
            return <MyItemLi key={myId()} data={item}/>
          })}
        </ul>
      </div>
    </div>
  );
};

export default Sections;
